import axios from 'axios';
import { API_URL } from '../config';
import { getAuthToken } from './authToken';

export type RepairKind =
  | 'ticket_attachment'
  | 'purchase_attachment'
  | 'ticket_cfv'
  | 'purchase_cfv'
  | 'document_answer';

export async function adminRepairAttachment(params: {
  kind: RepairKind;
  targetId: number;
  file: File;
  fileIndex?: number | null;
}): Promise<{ ok: boolean; file_path?: string }> {
  const token = getAuthToken();
  if (!token) {
    throw new Error('Usuário não autenticado');
  }
  const form = new FormData();
  form.append('kind', params.kind);
  form.append('target_id', String(params.targetId));
  if (params.fileIndex != null && params.fileIndex !== undefined) {
    form.append('file_index', String(params.fileIndex));
  }
  form.append('file', params.file);
  const { data } = await axios.post(`${API_URL}/api/attachments/admin/repair`, form, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
}
